import React, { useState } from 'react'
import CommonModal from '../../../../atoms/modal/CommonModal'
import ButtonCustom from '../../../../atoms/button/ButtonCustom'
import { Box, Tab, Tabs, useMediaQuery } from '@mui/material'
import VanueModal from '../WeddingSurvey/VanueModal'
import PhotographyModal from '../WeddingSurvey/PhotographyModal'
import CeremonyModal from '../WeddingSurvey/CeremonyModal'
import ReceptionModal from '../WeddingSurvey/ReceptionModal'
import CulturalModal from '../WeddingSurvey/CulturalModal'
import styles from '../index.module.scss'

const Modal = ({ activeModal, closeAllModals }) => {
	const [value, setValue] = useState(0)
	const [data, setData] = useState({})
	const isSmallScreen = useMediaQuery('(max-width:991px)')
	const handleChange = (event, newValue) => {
		setValue(newValue)
	}
	const mainTabStyle = {
		'& .MuiTabs-scrollButtons.Mui-disabled': {
			opacity: '0.3',
		},
		'&.MuiTabs-root': {
			minHeight: 'unset',
		},
		'& .MuiButtonBase-root': {
			padding: '11px 16px',
			minHeight: 'unset',
			fontSize: '14px',
			fontFamily: 'Inter',
			fontWeight: '500',
			color: '#313131',
			textTransform: 'capitalize',
			'&.Mui-selected': {
				color: '#7CA6BD',

				'& svg path': {
					stroke: '#7CA6BD',
				},
			},
		},
		'& .MuiTabs-indicator': {
			backgroundColor: '#7CA6BD',
		},
		'@media (max-width: 599px)': {
			'& .MuiButtonBase-root': {
				padding: '8px',
			},
		},
	}
	function CustomTabPanel(props) {
		const { children, value, index, ...other } = props

		return (
			<div
				role="tabpanel"
				hidden={value !== index}
				id={`simple-tabpanel-${index}`}
				aria-labelledby={`simple-tab-${index}`}
				{...other}
			>
				{value === index && <Box>{children}</Box>}
			</div>
		)
	}
	return (
		<CommonModal
			open={activeModal}
			handleClose={closeAllModals}
			heading="Wedding Survey"
			subHeading="Complete the details below to plan your perfect day"
			footerContent={
				<>
					<ButtonCustom
						onClick={closeAllModals}
						variant="outlined"
						size="lg"
					>
						Cancel
					</ButtonCustom>
					<ButtonCustom
						variant="default"
						size="lg"
						onClick={() => {}}
					>
						Create
					</ButtonCustom>
				</>
			}
			modalInner={styles.modalBody}
		>
			<Box sx={{ borderBottom: 1, borderColor: '#DFE4EB' }}>
				<Tabs
					value={value}
					onChange={handleChange}
					aria-label="basic tabs example"
					sx={mainTabStyle}
					variant={isSmallScreen ? 'scrollable' : 'standard'}
					scrollButtons={isSmallScreen ? 'auto' : false}
					allowScrollButtonsMobile={isSmallScreen}
				>
					<Tab
						label={
							<div className={styles.tabItem}>
								<span data-cy="VenueAndLocations">
									Venue & Locations
								</span>
							</div>
						}
					/>
					<Tab
						label={
							<div className={styles.tabItem}>
								<span data-cy="Photography">Photography</span>
							</div>
						}
					/>
					<Tab
						label={
							<div className={styles.tabItem}>
								<span data-cy="Ceremony">Ceremony</span>
							</div>
						}
					/>
					<Tab
						label={
							<div className={styles.tabItem}>
								<span data-cy="ReceptionAndEntertainment">
									Reception & Entertainment
								</span>
							</div>
						}
					/>
					<Tab
						label={
							<div className={styles.tabItem}>
								<span data-cy="CulturalRequirements">
									Cultural Requirements
								</span>
							</div>
						}
					/>
				</Tabs>
			</Box>
			<div className={styles.tabContentWrp}>
				<Box
					sx={{ width: '100%', margin: '10px 0' }}
					className={styles.mainTabs}
				>
					<CustomTabPanel
						value={value}
						index={0}
						className={styles.content}
					>
						<VanueModal data={data} setData={setData} />
					</CustomTabPanel>
					<CustomTabPanel
						value={value}
						index={1}
						className={styles.content}
					>
						<PhotographyModal />
					</CustomTabPanel>
					<CustomTabPanel
						value={value}
						index={2}
						className={styles.content}
					>
						<CeremonyModal />
					</CustomTabPanel>
					<CustomTabPanel
						value={value}
						index={3}
						className={styles.content}
					>
						<ReceptionModal />
					</CustomTabPanel>
					<CustomTabPanel
						value={value}
						index={4}
						className={styles.content}
					>
						<CulturalModal />
					</CustomTabPanel>
				</Box>
			</div>
		</CommonModal>
	)
}

export default React.memo(Modal)
